import locale from '../locale/default';

export default locale;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/locale-provider/default.js
// module id = ok3f
// module chunks = 16